module.exports = __webpack_public_path__ + "img/電気回路_6_4_1.91a6009d.png";